import { render, staticRenderFns } from "./TermsOfServiceForMerchantAgency.pug?vue&type=template&id=07f20f06&lang=pug&"
import script from "./TermsOfServiceForMerchantAgency.vue?vue&type=script&lang=js&"
export * from "./TermsOfServiceForMerchantAgency.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports